import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'legend-body',
  templateUrl: 'legend-body.component.html',
  styleUrls: ['legend-body.component.scss']
})
export class MapLegendBodyComponent implements OnInit {

  @Input() public legendList;
  @Input() private rangeArray;
  @Output() public onCloseClick: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }
}
